// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MApb0","title":"styles_title__T+adl"};